import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo12/parque.png";
import Imagen2 from "../../../images/modulo12/amigos.png";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo12/Unidad3Actividad1.mp3";

const Actividad2 = () => {
  const infoUnidad = modulo12.content[2];
  const infoAct = modulo12.content[2].activities[0];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo12.content[2].name}: ${modulo12.content[2].activities[1].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[2].path}/${modulo12.content[2].activities[1].path}`,
    titlePrev: `${modulo12.content[1].name}: ${modulo12.content[1].activities[11].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[1].path}/${modulo12.content[1].activities[11].path}`,
  };

  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo12.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul>
        <li>Observa las imágenes que se presentan a continuación:</li>
      </ul>

      <img src={Imagen1} className="img-fluid" alt="Peruanos" />
      <img src={Imagen2} className="img-fluid" alt="Peruanos" />
      <ul className="mt-4">
        <li>Ahora piensa y responde lo siguiente:</li>
      </ul>
      <div className="row">
        <div className="col-lg-10 col-12">
          <p>¿Qué piensa Jailer sobre el rol de los hombres?</p>
          <textarea className="form-control mb-3" rows={3} />
          <p>¿Qué opina María sobre eso?</p>
          <textarea className="form-control mb-3" rows={3} />
          <p>¿Qué opinas tú sobre el tema? ¿Por qué?</p>
          <textarea className="form-control mb-3" rows={3} />
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Explique a sus niños y niñas que comenzarán una nueva unidad. En
            esta unidad tratarán el tema de la discriminación y la desigualdad
            entre hombres y mujeres. El objetivo es que, a partir de la
            obtención de información, los niños y niñas tengan claro que pueden
            participar de acciones en contra de dicha desigualdad. Las
            actividades buscan que, a partir de la observación de imágenes,
            niños y niñas reflexionen y respondan preguntas sobre el tema.
          </li>

          <li>
            Lea la primera indicación: Observa las imágenes que se presentan a
            continuación. Pida a niños y niñas que observen y lean en silencio
            los globos de las imágenes en las que aparecen conversando Jailer y
            María. Pida a una niña y a un niño que lean los globos en voz alta.
          </li>

          <li>
            Lea la segunda indicación: Ahora piensa y responde lo siguiente:
            ¿Qué piensa Jailer sobre el rol de los hombres? ¿Qué opina María
            sobre eso? ¿Qué opinas tú sobre el tema? ¿Por qué?
          </li>

          <li>
            Proporcione un tiempo a los niños y niñas para que piensen en sus
            respuestas y, luego, pregunte qué respondieron a cada una de las
            preguntas. Por ejemplo:
            <ul>
              <li>
                <i>
                  “En la primera imagen, ¿qué piensa Jailer sobre el rol de los
                  hombres? (Posible respuesta: Jailer piensa que existen
                  trabajos que solo los hombres pueden realizar. María piensa
                  distinto. Ella sabe que puede trabajar en la profesión que
                  quiera). ¿Qué piensan ustedes? ¿Creen que hay profesiones que
                  son de hombres y de mujeres? (Posible respuesta: Durante mucho
                  tiempo, la mayoría pensaba como Jailer. Por ejemplo, se
                  pensaba que la cocina era un trabajo de mujeres y que solo los
                  hombres podían ser ingenieros. Hoy en día, si bien no se ha
                  logrado desterrar por completo estas creencias, se ha avanzado
                  muchísimo y las mujeres han demostrado que pueden desempeñarse
                  bien en cualquier profesión)”.
                </i>
              </li>
              <li>
                <i>
                  “¿Y qué podemos decir de la segunda imagen? (Posible
                  respuesta: Vemos que el papá de Jailer piensa que los hombres
                  son los que deben trabajar y mantener a sus esposas. María
                  sabe que no tiene que dejar su profesión si es que decide
                  casarse). ¿Qué piensan ustedes? ¿Los hombres deben mantener a
                  sus esposas? (Posible respuesta: En efecto, los hombres no
                  tienen que mantener a las mujeres. Hombres y mujeres pueden
                  colaborar con la economía del hogar y con el cuidado de los
                  hijos. Cada familia puede tomar su propia decisión
                  independientemente de los roles que la sociedad le impone a
                  las mujeres y los hombres)”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Cierre la actividad explicando que las sociedades tienen una serie
            de concepciones sobre el rol que deben tener los hombres y las
            mujeres, y que muchas veces estas concepciones ubican a la mujer en
            una posición inferior o de desventaja frente al hombre.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad2;
